// 平台能力判定 — 与 backend/internal/service/video/capability.go 对齐

/**
 * 是否需要 char image 资产审核（ARK-style asset:// 引用）。
 * Modelco 也有 char image 审核但走独立 UI，因此前端工具中只返回 ark + exchangetoken。
 */
export const platformRequiresAssetReview = (p?: string): boolean =>
  p === 'volcano-ark' || p === 'exchangetoken';

/**
 * 是否支持 Shot 资源审核（视频/音频/图片用户上传素材）。
 */
export const platformSupportsResourceReview = (p?: string): boolean =>
  p === 'volcano-ark' || p === 'exchangetoken';
